class PriceRangeFilter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("aria-listbox:change", (e) => {
      const [min, max] = e.detail.value
        .split(",")
        .map((value) => parseInt(value, 10));

      this.setInputValue(min, "[data-min]");
      this.setInputValue(max, "[data-max]");
    });
  }

  disconnectedCallback() {}

  setInputValue(value, selector) {
    const input = this.querySelector(selector);

    if (!input) return;

    if (!isFinite(value)) {
      input.removeAttribute("name");
      return;
    }

    input.setAttribute("name", input.dataset.name);
    input.value = value;
  }
}

if (!customElements.get("price-range-filter")) {
  customElements.define("price-range-filter", PriceRangeFilter);
}
